import { isNil } from 'ramda';

import { NestedTimeSheet } from 'src/types/resources/TimeSheet';

const toCents = (amount: string): number => Math.round(parseFloat(amount) * 100);

// the cost the server saves for an entry: rate × hours to the cent, half a cent to the even cent
const costInCents = (rate: string, hours: number): number => {
  const hundredthsOfCents = toCents(rate) * Math.round(hours * 100);
  const cents = Math.floor(hundredthsOfCents / 100);
  const rest = hundredthsOfCents % 100;
  if (rest === 50) {
    return cents % 2 === 0 ? cents : cents + 1;
  }
  return rest > 50 ? cents + 1 : cents;
};

// how much an adjustment to newHours changes the Talent's pay, as the server saves it: the new
// entry's cost at the Talent Pay Rate minus the saved cost of the entry it adjusts
export const talentAdjustmentAmount = (
  talentPayRate: string,
  newHours: number,
  originalTimeSheet: Pick<NestedTimeSheet, 'hours' | 'costTalentFeeIncluded'> | null,
): number => {
  const originalCost = isNil(originalTimeSheet?.costTalentFeeIncluded)
    ? costInCents(talentPayRate, Number(originalTimeSheet?.hours) || 0)
    : toCents(originalTimeSheet.costTalentFeeIncluded);

  return (costInCents(talentPayRate, newHours) - originalCost) / 100;
};
